
class TimeRangeGroupDetailViewController extends EntityListViewController {

    private backButton:MUIButton = null;
    private titleLabel:MUILabel = null;
    // private addButton:MUIButton = null;
    private saveButton:MUIButton = null;
    private startHourTextField:MUITextField = null;
    private endHourTextField:MUITextField = null;
    private durationLabel:MUILabel = null;
    private generateButton:MUIButton = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function(control){
            this.navigationController.popViewController(true);
        });

        this.titleLabel = MUIOutlet(this,'title-lbl', 'MUILabel');

        // this.addButton = MUIOutlet(this, 'add-btn', 'MUIButton');
        // this.addButton.setAction(this, function (){            
        //     this.showAddTimeRange();
        // });

        this.saveButton = MUIOutlet(this, 'save-btn', 'MUIButton');
        this.saveButton.setAction(this, function (){            
            DBHelper.saveMainContextWithCompletion(this, function(){
                this.updateUI();
            });
        });
        
        this.durationLabel = MUIOutlet(this, 'duration-lbl', 'MUILabel');

        // Start and end just update the group; the ranges are rebuilt with the Generate option
        this.startHourTextField = MUIOutlet(this, 'start-hour-tf', 'MUITextField');
        this.setupHourTextField(this.startHourTextField, (hour:string) => { this._timeRangeGroup.startHour = hour; });

        this.endHourTextField = MUIOutlet(this, 'end-hour-tf', 'MUITextField');
        this.setupHourTextField(this.endHourTextField, (hour:string) => { this._timeRangeGroup.endHour = hour; });

        this.generateButton = MUIOutlet(this, 'generate-btn', 'MUIButton');
        this.generateButton.setAction(this, this.showGenerateAlert);

        this.tableView = MUIOutlet(this,"table-view","UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;                
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        
        this.updateUI();
    }

    private _timeRangeGroup: TimeRangeGroup = null;
    set item(item:TimeRangeGroup){        
        this._timeRangeGroup = item;
    }   

    private updateUI(){
        if (this._timeRangeGroup == null) return;
        if (this.viewIsLoaded == false) return;

        this.titleLabel.text = MIOLocalizeString("TIME_RANGE_FOR", "TIME RANGE FOR") + " : " + this._timeRangeGroup.name;
        this.startHourTextField.text = this._timeRangeGroup.startHour;
        this.endHourTextField.text = this._timeRangeGroup.endHour;
        this.durationLabel.text = String(this._timeRangeGroup.duration ?? "");

        this.fetchedResultsController = null;
        this.tableView.reloadData();        
    }

    cellAtIndexPath(tableview, indexPath:MIOIndexPath){
        let cell:TimeRangeCell = tableview.dequeueReusableCellWithIdentifier("TimeRangeCell") as TimeRangeCell;
        let item:TimeRange = this.fetchedResultsController.objectAtIndexPath(indexPath) as TimeRange;
        cell.item = item;
        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){ 
        //this.selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath); 
        // let selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath);
        // this.showItemDetail(selectedItem); 
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            this.removeTimeRange(indexPath);
        }
    }

    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController() {
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let fetchRequest:MIOFetchRequest = null;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("nextDay", true), MIOSortDescriptor.sortDescriptorWithKey("hour", true)]; 
        let predicate = "timeRangeGroup.identifier == '" + this._timeRangeGroup.identifier + "'";
        //let predicate = null;
        fetchRequest = DBHelper.listFetchRequestWithEntityName("TimeRange", sortDescriptors, predicate);
        fetchRequest.relationshipKeyPathsForPrefetching = ['timeRangeGroup'];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;        
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){        
        this.tableView.reloadData();
    }

    //show notice functions
    private showAddTimeRange() {

        let duration = this._timeRangeGroup.duration;
        
        let fix_date_string = MIODateGetDateString(new Date()) + " " + this._timeRangeGroup.endHour;
        let fix_date = MIODateFromString(fix_date_string);
        fix_date = new Date(fix_date.getTime() - (duration * 60000));
        let group_end_hour = MIODateGetTimeString(fix_date); 

        let last_end_hour = MIODateGetTimeString(new Date(fix_date.getTime() + ( (duration * 2) * 60000)) );

        
        let dateString = MIODateGetDateString(new Date()) + " " + group_end_hour;
        let date = MIODateFromString(dateString);
        let new_date = new Date(date.getTime() + duration * 60000);        
        let hour = MIODateGetTimeString(new_date);
        let next_day = MIODateGetDateString(date) == MIODateGetDateString(new_date) ? false : true;


        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let tr = MIOEntityDescription.insertNewObjectForEntityForName("TimeRange", ad.managedObjectContext) as TimeRange;

        tr.timeRangeGroup = this._timeRangeGroup;
        tr.groupName = this._timeRangeGroup.name;
        tr.name = hour;
        tr.hour = hour;
        tr.duration = duration;
        tr.nextDay = next_day;
                
        this._timeRangeGroup.endHour = last_end_hour;
        this._timeRangeGroup.addTimeRangesObject(tr);

        DBHelper.saveMainContext();
    }

    private removeTimeRange(indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as TimeRange;
        DBHelper.deleteObjectFromMainContext(item, false);

        this.updateGroupHours(this.sortedRanges().filter(r => r !== item));
        DBHelper.saveMainContext();
        this.updateUI();
    }

    // --- Group hours ---

    // Ranges of the group ordered in time (next day ones last)
    private sortedRanges():TimeRange[] {
        let ranges = (this.fetchedResultsController.fetchedObjects as TimeRange[]).filter(r => r.deletedAt == null);
        return ranges.sort((a, b) => TimeRangeGroupDetailViewController.minutes(a) - TimeRangeGroupDetailViewController.minutes(b));
    }

    // Minutes since midnight of the group day (next-day ranges add 24h)
    private static minutes(range:TimeRange):number {
        let m = TimeRangeGroupDetailViewController.parseHour(range.hour) ?? 0;
        return m + (range.nextDay ? 1440 : 0);
    }

    // "HH:MM" -> minutes since midnight, or null
    private static parseHour(value:string):number {
        let m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(value ?? "");
        if (m == null) return null;
        let h = parseInt(m[1]), min = parseInt(m[2]);
        if (h > 23 || min > 59) return null;
        return h * 60 + min;
    }

    private static hourString(minutes:number):string {
        let m = ((minutes % 1440) + 1440) % 1440;
        let h = Math.floor(m / 60), min = m % 60;
        return (h < 10 ? "0" : "") + h + ":" + (min < 10 ? "0" : "") + min;
    }

    // Keep the group start/end consistent with its ranges: end = last range + interval
    private updateGroupHours(ranges:TimeRange[]) {
        if (ranges.length == 0) return;
        let duration = this._timeRangeGroup.duration || ranges[0].duration || 0;
        this._timeRangeGroup.startHour = ranges[0].hour;
        this._timeRangeGroup.endHour = TimeRangeGroupDetailViewController.hourString(TimeRangeGroupDetailViewController.minutes(ranges[ranges.length - 1]) + duration);
    }

    private setupHourTextField(textField:MUITextField, apply:(hour:string)=>void){
        textField.setOnChangeText(this, function(this:TimeRangeGroupDetailViewController, control:MUITextField, value:string){
            let minutes = TimeRangeGroupDetailViewController.parseHour(value);
            if (minutes != null) apply(TimeRangeGroupDetailViewController.hourString(minutes));
        });
        textField.setOnDidEndEditing(this, function(this:TimeRangeGroupDetailViewController, control:MUITextField){
            if (TimeRangeGroupDetailViewController.parseHour(control.text) == null && (control.text ?? "").trim().length > 0) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("INVALID_TIME", "INVALID TIME (HH:MM)"));
            }
            this.updateUI();
        });
    }

    // Generate option: asks the interval and rebuilds the ranges between the group start and end —
    // missing ones are created, leftovers deleted, matching ones kept (with their max orders).
    private showGenerateAlert(){
        let start = TimeRangeGroupDetailViewController.parseHour(this._timeRangeGroup.startHour);
        let end   = TimeRangeGroupDetailViewController.parseHour(this._timeRangeGroup.endHour);
        if (start == null || end == null) {
            AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("SET_START_AND_END_TIME_FIRST", "SET THE START AND END TIME FIRST"));
            return;
        }

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("GENERATE_TIME_RANGES","GENERATE TIME RANGES"), this._timeRangeGroup.startHour + " - " + this._timeRangeGroup.endHour, MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(this:TimeRangeGroupDetailViewController, textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("TIME_INTERVAL_IN_MINUTES_EG_15_30_ETC", "TIME INTERVAL IN MINUTES (EG. 15, 30, ETC.)"));
            textField.text = String(this._timeRangeGroup.duration || "");
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("GENERATE","GENERATE"), MUIAlertActionStyle.Default, this, function(this:TimeRangeGroupDetailViewController){
            let interval = parseInt(avc.textFields[0].text, 10);
            if (isNaN(interval) || interval <= 0 || interval > 1440) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("INVALID_TIME_INTERVAL", "INVALID TIME INTERVAL"));
                return;
            }
            this.generateTimeRanges(interval);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    private generateTimeRanges(interval:number){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let start = TimeRangeGroupDetailViewController.parseHour(this._timeRangeGroup.startHour);
        let end   = TimeRangeGroupDetailViewController.parseHour(this._timeRangeGroup.endHour);
        if (end <= start) end += 1440;   // end before start = next day

        // Wanted slots in minutes from the group day
        let wanted:number[] = [];
        for (let m = start; m < end; m += interval) wanted.push(m);
        let wantedSet = new Set(wanted);

        // Existing ranges: keep the matching ones, delete the rest
        let existing:{[minutes:number]:TimeRange} = {};
        for (let r of this.sortedRanges()) {
            let m = TimeRangeGroupDetailViewController.minutes(r);
            if (wantedSet.has(m) && existing[m] == null) { existing[m] = r; }
            else { DBHelper.deleteObjectFromMainContext(r, false); }
        }

        for (let m of wanted) {
            let tr = existing[m];
            if (tr == null) {
                tr = MIOEntityDescription.insertNewObjectForEntityForName("TimeRange", ad.managedObjectContext) as TimeRange;
                tr.identifier = MIOUUID.UUID().UUIDString;
                tr.hour = TimeRangeGroupDetailViewController.hourString(m);
                tr.name = tr.hour;
                tr.groupName = this._timeRangeGroup.name;
                tr.nextDay = m >= 1440;
                tr.timeRangeGroup = this._timeRangeGroup;
            }
            tr.duration = interval;
        }

        this._timeRangeGroup.duration = interval;

        DBHelper.saveMainContext();
        this.updateUI();
    }
}
